import { Avatar, RouterLink, Tooltip } from '@infl-ts/ui-advocate-components';
import ChatIcon from '@mui/icons-material/ChatBubble';
import PersonIcon from '@mui/icons-material/Person';
import { Box, IconButton, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MemberActions = function MemberActions(_ref) {
  var memberId = _ref.memberId;
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "MemberActions",
    "data-source-file": "like-item.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex'
        },
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: t('Go to profile'),
          children: /*#__PURE__*/_jsx(IconButton, {
            component: RouterLink,
            to: "/profiles/".concat(memberId),
            children: /*#__PURE__*/_jsx(PersonIcon, {
              sx: {
                height: 20,
                width: 20
              }
            })
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: t('Chat'),
          children: /*#__PURE__*/_jsx(IconButton, {
            component: RouterLink,
            to: "/chat?p=".concat(memberId),
            children: /*#__PURE__*/_jsx(ChatIcon, {
              sx: {
                height: 20,
                width: 20
              }
            })
          })
        })]
      });
    }
  });
};

var LikeItem = function LikeItem(_ref2) {
  var member = _ref2.member,
      showActions = _ref2.showActions;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      mx: 3,
      mb: 2,
      alignItems: 'center'
    },
    "data-element": "Box",
    "data-component": "LikeItem",
    "data-source-file": "like-item.tsx",
    children: [/*#__PURE__*/_jsx(Avatar, {
      member: member,
      disabledPopover: true,
      "data-element": "Avatar",
      "data-component": "LikeItem",
      "data-source-file": "like-item.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        ml: 1,
        flexGrow: 3
      },
      "data-element": "Box",
      "data-source-file": "like-item.tsx",
      children: [/*#__PURE__*/_jsx(Typography, {
        component: "div",
        sx: {
          fontWeight: function fontWeight(t) {
            return t.typography.fontWeightBold;
          }
        },
        "data-element": "Typography",
        "data-source-file": "like-item.tsx",
        children: member.name
      }), member.title && /*#__PURE__*/_jsx(Typography, {
        component: "div",
        variant: "body2",
        sx: {
          color: function color(t) {
            return t.palette.text.secondary;
          }
        },
        children: member.title
      })]
    }), showActions && /*#__PURE__*/_jsx(MemberActions, {
      memberId: member.id
    })]
  });
};

export default LikeItem;